module.exports = __webpack_public_path__ + "img/map-dqnm.d2e154e5.png";